export default __webpack_public_path__ + "static/media/la2m_choice.0350d0e2.svg";